import script from "./SportSections.vue?vue&type=script&setup=true&lang=js"
export * from "./SportSections.vue?vue&type=script&setup=true&lang=js"

import "./SportSections.vue?vue&type=style&index=0&id=783f9cce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783f9cce"]])

export default __exports__